export const bancoOptions = [
  {
    label: '001 - Banco do Brasil S.A.',
    value: '001'
  },
  {
    label: '003 - Banco da Amazônia S.A.',
    value: '003'
  },
  {
    label: '004 - Banco do Nordeste do Brasil S.A.',
    value: '004'
  },
  {
    label: '021 - BANESTES S.A. Banco do Estado do Espírito Santo',
    value: '021'
  },
  {
    label: '029 - Banco Itaú Consignado S.A.',
    value: '029'
  },
  {
    label: '033 - BANCO SANTANDER (BRASIL) S.A.',
    value: '033'
  },
  {
    label: '036 - Banco Bradesco BBI S.A.',
    value: '036'
  },
  {
    label: '037 - Banco do Estado do Pará S.A.',
    value: '037'
  },
  {
    label: '041 - Banco do Estado do Rio Grande do Sul S.A.',
    value: '041'
  },
  {
    label: '063 - Banco Bradescard S.A.',
    value: '063'
  },
  {
    label: '070 - BRB - Banco de Brasília S.A.',
    value: '070'
  },
  {
    label: '077 - Banco Inter S.A.',
    value: '077'
  },
  {
    label: '079 - PICPAY BANK - BANCO MÚLTIPLO S.A',
    value: '079'
  },
  {
    label: '104 - Caixa Econômica Federal',
    value: '104'
  },
  {
    label: '113 - NEON CORRETORA DE TÍTULOS E VALORES MOBILIÁRIOS S.A.',
    value: '113'
  },
  {
    label: '121 - Agibank',
    value: '121'
  },
  {
    label: '140 - NU INVEST CORRETORA DE VALORES S.A.',
    value: '140'
  },
  {
    label: '174 - PEFISA S.A. - CRÉDITO',
    value: '174'
  },
  {
    label: '184 - Banco Itaú BBA S.A.',
    value: '184'
  },
  {
    label: '208 - Banco BTG Pactual S.A.',
    value: '208'
  },
  {
    label: '237 - Banco Bradesco S.A.',
    value: '237'
  },
  {
    label: '260 - Nu Pagamentos S.A (Nubank)',
    value: '260'
  },
  {
    label: '260 - NU PAGAMENTOS S.A. - INSTITUIÇÃO DE PAGAMENTO',
    value: '260'
  },
  {
    label: '280 - WILL FINANCEIRA S.A. CRÉDITO',
    value: '280'
  },
  {
    label: '290 - PAGSEGURO INTERNET INSTITUIÇÃO DE PAGAMENTO S.A.',
    value: '290'
  },
  {
    label: '318 - Banco BMG S.A.',
    value: '318'
  },
  {
    label: '323 - MERCADO PAGO INSTITUIÇÃO DE PAGAMENTO LTDA.',
    value: '323'
  },
  {
    label: '336 - Banco C6 S.A.',
    value: '336'
  },
  {
    label: '340 - SUPERDIGITAL INSTITUIÇÃO DE PAGAMENTO S.A.',
    value: '340'
  },
  {
    label: '341 - ITAÚ UNIBANCO S.A.',
    value: '341'
  },
  {
    label: '380 - PICPAY INSTITUIçãO DE PAGAMENTO S.A.',
    value: '380'
  },
  {
    label: '389 - Banco Mercantil do Brasil S.A.',
    value: '389'
  },
  {
    label: '413 - BANCO BV S.A.',
    value: '413'
  },
  {
    label: '422 - Banco Safra S.A.',
    value: '422'
  },
  {
    label: '473 - Banco Caixa Geral - Brasil S.A.',
    value: '473'
  },
  {
    label: '530 - Banco B.UNI',
    value: '530'
  },
    {
    label: '536 - Banco Neon Pagamentos S.A.',
    value: '536'
  },
  {
    label: '566 - Banco B.UNI',
    value: '566'
  },
  {
    label: '623 - Banco Pan S.A.',
    value: '623'
  },
  {
    label: '748 - BANCO COOPERATIVO SICREDI S.A.',
    value: '748'
  },
  {
    label: '756 - BANCO COOPERATIVO SICOOB S.A. - BANCO SICOOB',
    value: '756'
  },
  {
    label: '1722480 - Banco Quero-Quero VerdeCard Instituição de Pagamento S.A',
    value: '1722480'
  }
]

export const tipoContaOptions = [
  {
    label: 'Corrente',
    value: 'Corrente'
  },
  {
    label: 'Poupança',
    value: 'Poupança'
  }
]


export const tipoChavePixOptions = [
  {
    label: 'Chave Aleatória',
    value: 'Chave Aleatória'
  },
  {
    label: 'CPF',
    value: 'CPF'
  },
  {
    label: 'CNPJ',
    value: 'CNPJ'
  },
  {
    label: 'E-mail',
    value: 'E-mail'
  },
  {
    label: 'Telefone',
    value: 'Telefone'
  }
]
